export default {
    menu_label: 'Marketing leads',

    yes: 'Yes',
    no: 'No',

    referral_leakage_audit: {
        menu_label: 'Referral leakage audit',
        heading: 'Referral leakage audit leads',
        no_leads: 'No audit leads found',

        table: {
            submitted_at: 'Submitted',
            name: 'Name',
            email: 'Email',
            score: 'Score',
            band: 'Band',
            utm_source: 'UTM source',
            email_sent: 'Email sent',
        },

        modal: {
            title: 'Audit lead details',
            answers: 'Answers',
            utm: 'UTM',
            integrations: 'Integrations',
        },
    },
}
